import { IItemState } from '@/store/item';
import { IItemGetters } from './getters.types';
import { IItem, Item } from '@/models';

export const getters: IItemGetters = {
  getItems(state: IItemState): IItem[] {
    return state.items.map(data => new Item(data));
  },

  getItemById: (state: IItemState) => (itemId: string): IItem | undefined => {
    const data = state.items.find(({ item }) => item === itemId);
    if (!data) {
      return undefined;
    }

    return new Item(data);
  },

  getItemCount(state: IItemState): number {
    return state.count;
  }
};
